import { render } from "./JournalEntryDetailsModal.vue?vue&type=template&id=dbfd0a0e"
import script from "./JournalEntryDetailsModal.vue?vue&type=script&lang=js"
export * from "./JournalEntryDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__